import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowLeftSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M2 12.094C2 12.3283 2.10337 12.5402 2.29113 12.7185L9.49044 19.9296C9.67821 20.1037 9.8807 20.1881 10.1054 20.1881C10.5696 20.1881 10.9262 19.841 10.9262 19.3758C10.9262 19.1511 10.8513 18.9263 10.6962 18.7808L7.87465 15.916L3.90186 12.27L3.70556 12.7503L7.02958 12.939H21.1646C21.6529 12.939 22 12.5824 22 12.094C22 11.6056 21.6529 11.2491 21.1646 11.2491H7.02958L3.70556 11.4378L3.90186 11.9276L7.87465 8.27203L10.6962 5.40731C10.8556 5.25746 10.9262 5.03698 10.9262 4.81225C10.9262 4.34708 10.5696 4 10.1054 4C9.8807 4 9.66971 4.0844 9.4521 4.29677L2.29113 11.4696C2.10337 11.6478 2 11.8598 2 12.094Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowLeftSvg };
